import { platformEnv } from '@/platform/config/env'
import { createHttpClient } from '@/platform/http/client'
import type { Taxonomy, TaxonomyInput, TaxonomyTerm, TaxonomyTermInput } from '../model/taxonomy'
import type { CatalogOptimizationPlan, CatalogOptimizationScope } from './catalogAiApi'

const client = createHttpClient(platformEnv.ecomApiUrl)
const basePath = '/v1/admin/catalogs/taxonomies'

export const taxonomiesApi = {
  async getTree() {
    const response = await client.request<{ taxonomies: Taxonomy[]; terms: TaxonomyTerm[] }>({ url: `${basePath}/tree` })
    return response.data
  },
  async get(id: number) {
    const response = await client.request<Taxonomy>({ url: `${basePath}/${id}` })
    return response.data
  },
  async create(input: TaxonomyInput) {
    const response = await client.request<Taxonomy>({ url: basePath, method: 'POST', data: input })
    return response.data
  },
  async update(id: number, input: Partial<TaxonomyInput>) {
    const response = await client.request<Taxonomy>({ url: `${basePath}/${id}`, method: 'PATCH', data: input })
    return response.data
  },
  async remove(id: number) {
    await client.request<void>({ url: `${basePath}/${id}`, method: 'DELETE' })
  },
  async createTerm(taxonomyId: number, input: TaxonomyTermInput) {
    const response = await client.request<TaxonomyTerm>({ url: `${basePath}/${taxonomyId}/terms`, method: 'POST', data: input })
    return response.data
  },
  async updateTerm(taxonomyId: number, termId: number, input: Partial<TaxonomyTermInput>) {
    const response = await client.request<TaxonomyTerm>({
      url: `${basePath}/${taxonomyId}/terms/${termId}`,
      method: 'PATCH',
      data: input,
    })
    return response.data
  },
  async removeTerm(taxonomyId: number, termId: number) {
    await client.request<void>({ url: `${basePath}/${taxonomyId}/terms/${termId}`, method: 'DELETE' })
  },
  async applyOptimization(plan: CatalogOptimizationPlan, scope: CatalogOptimizationScope) {
    const response = await client.request<{ taxonomy_changes: number; term_changes: number }>({
      url: `${basePath}/optimization/apply`, method: 'POST',
      data: { scope, taxonomy_changes: plan.taxonomy_changes, term_changes: plan.term_changes },
    })
    return response.data
  },
}
